export enum MachineScheduleActionEnum {
  Restart,
  ShutDown,
  RestartApp
}
